export const normalize_question_type = (value) => String(value || '')
  .replace(/-/g, '_')
  .replace(/\s+/g, '_')
  .toLowerCase();

export const normalize_choice_key = (value) => String(value || '')
  .trim()
  .toLowerCase();

const first_defined = (...values) => values.find((value) => value !== undefined && value !== null);

const get_question_choice_sources = (question = {}) => (
  first_defined(
    question?.multi_select_choices,
    question?.multi_select_options,
    question?.options,
    question?.choices,
    question?.question_options,
    question?.option_values,
    question?.question_choices,
    [],
  )
);

const to_choice_array = (sources) => (
  Array.isArray(sources) ? sources : String(sources || '').split(',')
);

const extract_choice_id = (choice, index) => {
  const choice_id = Number(
    first_defined(
      choice?.option_id,
      choice?.question_option_id,
      choice?.choice_id,
      choice?.value_id,
      choice?.id,
      index + 1,
    ),
  );

  return Number.isFinite(choice_id) && choice_id > 0 ? choice_id : index + 1;
};

const extract_choice_label = (choice) => String(
  first_defined(
    choice?.choice,
    choice?.value,
    choice?.option,
    choice?.name,
    choice?.label,
    choice?.text,
    '',
  ),
).trim();

const normalize_choice_item = (choice, index) => {
  const normalized_choice =
    choice && typeof choice === 'object'
      ? {
          id: extract_choice_id(choice, index),
          label: extract_choice_label(choice),
        }
      : {
          id: index + 1,
          label: String(choice || '').trim(),
        };

  return normalized_choice;
};

export const extract_question_choice_items = (question = {}) => {
  const normalized_sources = to_choice_array(get_question_choice_sources(question));

  return normalized_sources
    .map(normalize_choice_item)
    .filter((choice) => choice.label);
};

export const extract_question_choice_labels = (question = {}) => (
  extract_question_choice_items(question).map((choice) => choice.label)
);
